import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import useGetProfile from './useGetProfile';
import useUpdateClient from './useUpdateClient';

const ENDPOINT = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://property-tax-api.yourwayhome.com';

interface Payload {
  emailAddress: string;
  clientFirstName: string;
  clientLastName: string;
  clientId: string;
}

export default function useInviteClient() {
  const queryClient = useQueryClient();
  const { data: profile } = useGetProfile();
  const { mutate: updateClient } = useUpdateClient();

  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      updateClient(
        {
          id: payload.clientId,
          inviteSent: new Date().toISOString(),
          _id: payload.clientId,
        },
        {
          onSuccess: async () => {
            const response = await fetch(
              `${ENDPOINT}/api/v1/common/email/invite`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  clientFirstName: payload.clientFirstName,
                  clientLastName: payload.clientLastName,
                  emailAddress: payload.emailAddress,
                  agentName: profile?.firstName,
                  agentBranding: profile?.identifier,
                }),
              },
            );

            if (!response.ok) {
              throw new Error(
                `Failed to fetch profile: ${response.statusText}`,
              );
            }

            return (await response.json()).data;
          },
        },
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['CLIENTS'] });
    },
  });
}
